<style scoped>
#nomenu_container {
	padding: 0px;
	width: 100%;
	height: 100%;
}
</style>

<template>
	<div id="nomenu_container">
		<router-view/>
	</div>
</template>

<script>
export default {
	name: "NoMenyContainer",
	data() {
		return {
			/* nothing */
		}
	},
}
</script>